import axios from 'axios'

export interface IExternalDeps {
  envs: {
    BASE_ENV_URL: string
    PRODUCT_APP_URL_API: string
    PRODUCT_APP_URL_I18N: string
    PRODUCT_APP_URL_CONFIGURATOR: string
    PRODUCT_APP_URL_PROFILE: string
    PRODUCT_APP_URL_WORKSPACE: string
    PRODUCT_APP_URL_PULSE: string
    PRODUCT_APP_URL_CSR: string
    PRODUCT_APP_URL_TROVE: string
    PRODUCT_APP_URL_MAP: string
    PRODUCT_APP_URL_EDGE: string
    PRODUCT_APP_URL_BI: string
    PRODUCT_APP_URL_HCM: string
    PRODUCT_APP_URL_ORGANIZATION: string
    PRODUCT_APP_URL_OKR: string
    PRODUCT_APP_URL_REACH: string
    PRODUCT_APP_URL_PDO: string
    PRODUCT_APP_URL_AMC: string
    PRODUCT_APP_URL_TIMESHEET: string
    ENV_VAR_ME_TO: string
    OAUTH_HOST: string
    [envKey: string]: unknown
  }
  axios: typeof axios
  container: HTMLElement | HTMLDivElement
  getAccessToken: () => string
  redirectToSSO: () => void
  lang: string
  getContentElement: (element: HTMLDivElement) => void
}

export let externalDeps: IExternalDeps

export function initExternalDeps(value: IExternalDeps) {
  externalDeps = value
}

export async function initExternalDepsForDevelopment() {
  const envRes = await (
    await fetch('https://envs.dev.meeraspace.com/key/env%2FGLOBAL_FE_ENV_VARS')
  ).json()

  const envs = {
    ...JSON.parse(envRes.value),
    // overrides here
    // PRODUCT_APP_URL_WORKSPACE: 'custom URL',
  }

  const API_KEYWORDS = [
    new URL(envs.PRODUCT_APP_URL_WORKSPACE).host,
    new URL(envs.PRODUCT_APP_URL_I18N).host,
    new URL(envs.PRODUCT_APP_URL_CONFIGURATOR).host,
  ]

  const getAccessToken = () => {
    const token = window.localStorage.getItem('access_token')
    if (token == null) {
      window.location.href = '/input-access-token.html'
      return ''
    } else {
      return token
    }
  }
  const redirectToSSO = () => {
    window.location.href = '/input-access-token.html'
  }

  axios.interceptors.request.use((config) => {
    let shouldAddToken = false

    try {
      const { host } = new URL(config.url ?? '')

      console.log('ffff')
      console.log(host, API_KEYWORDS)

      if (host == null) {
        shouldAddToken = false
      } else {
        for (const keyword of API_KEYWORDS) {
          if (host.endsWith(keyword)) {
            shouldAddToken = true
            break
          }
        }
      }
    } catch {}

    console.log(shouldAddToken)

    if (shouldAddToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${getAccessToken()}`
    }

    return config
  })

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response.status === 401) {
        let shouldJumpToLogin = false

        try {
          const { host } = new URL(error.response.config.url)

          if (host == null) {
            shouldJumpToLogin = false
          } else {
            for (const keyword of API_KEYWORDS) {
              if (host.endsWith(keyword)) {
                shouldJumpToLogin = true
                break
              }
            }
          }
        } catch {}

        if (shouldJumpToLogin) {
          redirectToSSO()
        }
      }
      return await Promise.reject(error)
    },
  )

  externalDeps = {
    envs,
    axios,
    container: document.body,
    getAccessToken,
    redirectToSSO,
    lang: 'en-US',
    getContentElement: () => {},
  }
}
